<div *ngIf="location === 'websites'" class="carousel row">
  <dx-gallery
    *ngIf="location === 'websites'"
    class="carousel col-12"
    #gallery
    id="gallery"
    [dataSource]="carouselSubject"
    [height]="'auto'"
    [width]="600"
    [loop]="true"
    [slideshowDelay]="6000"
    [showNavButtons]="false"
    [showIndicator]="true"
  >
    <div *dxTemplate="let galleryItem of 'item'">
      <div class="carousel-container">
        <img
          class="carouel-subject-image"
          alt="{{ galleryItem.alt }}"
          src="{{ galleryItem.image }}"
        />
        <p class="carousel-subject-copy text-wrap text-center">
          {{ galleryItem.copy }}
        </p>
      </div>
    </div>
  </dx-gallery>
</div>

<div *ngIf="type === 'stepcards'" class="carousel-cards row">
  <dx-gallery
    class="carousel"
    #gallery
    id="gallery"
    [dataSource]="carouselSubject"
    [height]="'auto'"
    [width]="'100%'"
    [loop]="true"
    [showNavButtons]="!mobileUser"
    [showIndicator]="false"
  >
    <div *dxTemplate="let galleryItem of 'item'">
      <div class="mb-3">
        <app-step-card [card]="galleryItem"></app-step-card>
      </div>
    </div>
  </dx-gallery>
</div>
